module.exports = __webpack_public_path__ + "img/logo2.73c6f8c5.png";